import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './components/modal/modal.component';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  userProfile: any = null;
  entityProfile: any = null;
  isLoading: boolean = true;
  showModal: boolean = false;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.loadUserProfile();
  }

  loadUserProfile(): void {
    this.userService.getUserInfo().subscribe(
      (data) => {
        this.userProfile = {
          name: data['custom:nombre'] || 'No disponible',
          lastName: data['custom:apellidos'] || 'No disponible',
          tipoDocumento: data['custom:tipoDoc'] || 'No disponible',
          id: data['custom:numeroDoc'] || 'No disponible',
          city: data['custom:ciudad'] || 'No disponible',
          department: data['custom:departamento'] || 'No disponible',
          address: data['custom:direccion'] || 'No disponible',
          phone: data['custom:phone'] || 'No disponible',
          email: data['email'] || 'No disponible',
          role: data['custom:cargo'] || 'No disponible',
          photo: data['custom:photo'] || 'usuario.webp',
        };

        this.entityProfile = {
          name: data['custom:nombreEntidad'] || 'No disponible',
          nit: data['custom:numeroDocEntidad'] || 'No disponible',
          email: data['custom:institutionalEmail'] || 'No disponible',
          phone: data['custom:phoneNumber'] || 'No disponible',
          address: data['custom:physicalAddress'] || 'No disponible',
          city: data['custom:department'] || 'No disponible',
          logo: data['custom:logoEntidad'] || 'emblema.webp',
        };
        this.loadEntityProfile(this.entityProfile.nit);
      },
      (error) => {
        console.error('Error obteniendo datos del usuario:', error);
      }
    );
  }

  loadEntityProfile(nit: string): void {
    this.userService.getEntityByDocument(nit).subscribe(
      entity => {
        this.entityProfile = {
          name: entity.entityType || "No disponible",
          nit: entity.entityDocNumber || "No disponible",
          email: entity.institutionalEmail || "No disponible",
          phone: entity.phoneNumber || "No disponible",
          address: entity.physicalAddress || "No disponible",
          city: entity.department || "No disponible",
          logo: entity.logoPath || "emblema.webp"
        };
      },
      error => {
        console.error('Error cargando entidad:', error);
      }
    );
  }

  updateProfile(updatedUser: any) {
    const idToken = localStorage.getItem('id_token');
  
    const payload: any = {};
    const allowedFields = ['name', 'lastName', 'email', 'phone'];
  
    for (const field of allowedFields) {
      if (updatedUser[field] !== null && updatedUser[field] !== undefined && updatedUser[field] !== '') {
        payload[field] = updatedUser[field];
      }
    }

    if (!idToken) {
      console.error('Token no encontrado. No se puede actualizar el perfil.');
      return;
    }
    
    this.userService.updateUser(payload, idToken, this.userProfile.tipoDocumento, this.userProfile.id).subscribe({
      next: (response) => {
        this.userProfile = { ...this.userProfile, ...payload };
        this.closeModal();
      },
      error: (err) => {
        console.error('Error al actualizar el perfil:', err);
      }
    });
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }
  
}
